const $menuItems = document.querySelectorAll('.Navigation__menu li.-has-children');

if ($menuItems.length) {
    const $body = document.querySelector('body');
    $menuItems.forEach(($item) => {
        $item.addEventListener('mouseover', () => {
            if (!$body.classList.contains('-show-mobile-nav')) {
                $body.classList.add('-is-hover-subnav');
            }
        });
        $item.addEventListener('mouseleave', () => {
            if (!$body.classList.contains('-show-mobile-nav')) {
                $body.classList.remove('-is-hover-subnav');
            }
        });
    });
}
